import * as bootstrap from "bootstrap";

// export const enablePopovers = (function () {
//     var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
//     var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
//         return new bootstrap.Popover(popoverTriggerEl);
//     });
// })();

// export const enableCollapsibles = (() => {
//     const collapseElementList = document.querySelectorAll('.collapse');
//     const collapseList = [...collapseElementList].map((collapseEl) => new bootstrap.Collapse(collapseEl, { toggle: false }));
// })();

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));

/**
 *
 * @param {string} name The id of the modal
 * @param {object} options The options you want to give it.
 * - Add a close button through options.modalHeader = true. You can also set extra html. The close button will always be added if you use this.
 * - Set the body with custom html via options.modalBody
 * - Set the footer with custom html or to have a simpel dismiss button set options.Modalfooter to true.
 * @returns A bootstrap modal
 */
export function createModalPlaceholder(name, options = false, closeBtn = true, staticBackdrop = false) {
	// Options
	let headerContent = "";
	let header = "";

	if (options.modalHeader) {
		if (typeof options.modalHeader === "string") {
			headerContent = `<h5 class="modal-title oswald" id="${name}Label">${options.modalHeader}</h5>`;
		}

		if (closeBtn) headerContent += '<button role="button" class="btn-close" data-bs-dismiss="modal"></button>';

		header = `<div class="modal-header">${headerContent ?? ""}</div>`;
	}

	let footer = "";

	if (options.modalFooter) {
		footer = `<div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" data-bs-dismiss="modal">Sluiten</button>
      </div>`;
	}

	let body = options.modalBody || "";

	// Create HTML
	const modal = document.createElement("div");
	modal.classList.add("modal", "fade");
	modal.id = name;
	modal.tabIndex = "-1";
	modal.ariaLabelledby = `${name}Label`;
	modal.ariaHidden = true;
	modal.innerHTML = `
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          ${header}
          <div class="modal-body">
          ${body}
          </div>
         ${footer}
        </div>
    </div>`;

	if (staticBackdrop) {
		modal.dataset.bsBackdrop = "static";
		modal.dataset.bsKeyboard = false;
		modal.tabIndex = "-1";
	}

	document.body.append(modal);

	return new bootstrap.Modal(modal);
}

// Make it accessible for other js files, janky hack m8
window.loveliTheme = {
	createModalPlaceholder,
};

// Show toasts when cart is updated
const showToasts = () => {
	const toastEls = document.querySelectorAll(".woocommerce-message .toast");

	console.log("yes");

	if (!toastEls.length) return;

	const toasts = [...toastEls].map((toastEl) => new bootstrap.Toast(toastEl));

	toasts.forEach((toast) => {
		document.querySelector(".woocommerce-notices-wrapper").append(toast._element);
		toast.show();
	});
};

// Callback function for MutationObserver
const observeNotices = function (mutationsList, observer) {
	for (const mutation of mutationsList) {
		if (mutation.type === "childList") {
			let lsDoIt = false;
			for (const node of mutation.addedNodes) {
				if (!node.classList) continue;

				if (node.classList.contains("woocommerce-message") || node.classList.contains("woocommerce-NoticeGroup")) {
					lsDoIt = true;
				}
			}

			if (lsDoIt) showToasts();
		}
	}
};

// Create a MutationObserver instance
const observer = new MutationObserver(observeNotices);

// Define the options for the observer (specify which mutations to observe)
const observerOptions = {
	childList: true, // Watch for changes in the child nodes of the target
	subtree: true, // Watch for changes in all descendant nodes of the target
};

observer.observe(document.body, observerOptions);

const searchbar = document.querySelector("#collapse-search");
export const searchFocusBlur = (() => {
	if (searchbar !== null) {
		searchbar.addEventListener("shown.bs.collapse", () => {
			document.addEventListener("click", hideSearchBar);
		});

		searchbar.addEventListener("hidden.bs.collapse", () => {
			document.removeEventListener("click", hideSearchBar);
		});
	}
})();

function hideSearchBar(e) {
	const searchCollapse = new bootstrap.Collapse("#collapse-search", {
		toggle: false,
	});
	if (!searchbar.contains(e.target)) {
		searchCollapse.hide();
	}
}

/**
 * Creates a bootstrap toast
 * @param {string} heading The header
 * @param {mixed} body The html for the body
 * @returns a bootstrap Toast
 */
export function createToast(heading = false, body = "") {
	const toastPlaceholder = document.querySelector("#main-toast-placeholder");
	const toast = document.createElement("div");
	toast.classList.add("toast", "border-0");
	toast.role = "alert";
	toast.ariaLive = "assertive";
	toast.ariaAtomic = "true";

	if (heading) {
		toast.innerHTML += `
        <div class="toast-header">
            <strong class="me-auto">${heading}</strong>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        `;
	}

	toast.innerHTML += `
    <div class="toast-body">
        ${body}
    </div>
    `;

	toastPlaceholder.append(toast);

	return new bootstrap.Toast(toast, {
		animation: true,
		autohide: false,
	});
}
